import { CrmRepository } from "src/containers/crm/repositories/crm/crm-repository";
import { DI } from "src/infra/di/container";
import { Log } from "src/libs/log";
import { HttpClient } from "src/infra/http/client";
import { HttpUtils } from "src/infra/http/utils";
import { Logger } from "src/infra/logging/logger";
import { HouseholdClaimRepository } from "src/containers/household-claim/repositories/claim/household-claim.repository";
import { HouseholdRepository } from "src/containers/household/repositories/household/household.repository";
import { PaymentSummaryRepository } from "src/containers/payments/repositories/payment-summary/payment-summary";
import { VehiclesRepository } from "src/containers/vehicles/repositories/vehicles/vehicles-repository";
import { NotificationsRepository } from "src/containers/configuration/repositories/notifications/notifications-repository";
import { RepaymentObligationsRepository } from "src/containers/repayment-obligations/repositories/repayment-obligation/repayment-obligation-repository";
import { AdvertisingRepository } from "src/containers/home/repositories/banner/banner-repository";
import { MedicineDeliveryDocumentRepository } from "src/domains/medicine-delivery/repositories/document/document-repository";
import { MedicineDeliveryRepository } from "src/domains/medicine-delivery/repositories/delivery/delivery-medicine-repository";
import { SurveysRepository } from "src/containers/surveys/repositories/survey/surveys-repository";
import { GeolocationRepository } from "src/shared/repositories/geolocation/geolocation-repository";
import { AuthenticationRepository } from "src/containers/authentication/repositories/authentication/authentication-repository";
import { PlanKilometersRepository } from "src/containers/vehicles/repositories/plan-kilometers/plan-kilometers-repository";
import { PolicyRepository } from "src/containers/insurances/repositories/policy/policy-repository";
import { PolicyDetailRepository } from "src/containers/insurances/repositories/policy-detail/policy-detail-repository";
import { BenefitDiscountsRepository } from "src/containers/wellbeing/discounts/repositories/discounts/discounts-repository";
import { VehicleClaimRepository } from "src/containers/vehicle-claims/repositories/claims/claims-repository";
import { RentalRepository } from "src/containers/rental/repositories/rental/rental-repository";
import { LifeRepository } from "src/containers/life/repositories/life/life-repository";
import { DocumentsDownloadRepository } from "src/containers/documents-download/repositories/documents-download/documents-download-repository";
import { VoucherDownloadRepository } from "src/containers/documents-download/repositories/voucher-download/voucher-download-repository";
import { CrmRequestRepository } from "src/containers/requests/repositories/crm-requests/crm-request-repository";
import { CrmRequestsService } from "src/containers/requests/services/crm-requests/crm-requests-service";
import { NotificationsService } from "src/containers/configuration/services/notifications/notifications.service";
import { DocumentsDownloadService } from "src/containers/documents-download/services/document-download/documents-download.service";
import { StaticDocumentDownloadService } from "src/containers/documents-download/services/static-document-download/static-document-download.service";
import { LifeService } from "src/containers/life/services/life.service";
import { RentalService } from "src/containers/rental/services/rental.service";
import { VehicleClaimService } from "src/containers/vehicle-claims/services/claims.service";
import { BenefitDiscountsService } from "src/containers/wellbeing/discounts/services/discount/discounts-service";
import { BenefitServingService } from "src/containers/wellbeing/servings/services/serving/serving";
import { AuthenticationService } from "src/containers/authentication/services/authentication/authentication-service";
import { SessionService } from "src/containers/authentication/services/session/session-service";
import { VoucherDownloadService } from "src/containers/documents-download/services/voucher-download/voucher-download-service";
import { HealthCarnetService } from "src/containers/health-traveler-carnet/services/health-carnet-service";
import { AdvertisingService } from "src/containers/home/services/banner-service/banner-service";
import { HouseholdClaimService } from "src/containers/household-claim/services/claim/household-claim.service";
import { HouseholdService } from "src/containers/household/services/household/household-service";
import { PolicyBridgeService } from "src/containers/insurances/services/policy-bridge/policy-bridge-service";
import { PolicyService } from "src/containers/insurances/services/policy/policy-service";
import { RepaymentObligationsService } from "src/containers/repayment-obligations/services/repayment-obligation/repayment-obligation-service";
import { SurveysService } from "src/containers/surveys/services/surveys-service/surveys-service";
import { PolicyDetailService } from "src/containers/insurances/services/policy-detail/policy-detail-service";
import { PaymentSummaryService } from "src/containers/payments/services/payment-summary/payment-summary";
import { OtpService } from "src/containers/otp/services/otp-service/otp-service";
import { PaymentsStorageService } from "src/containers/payments/services/storage-service/storage-service";
import { PlanKilometersService } from "src/containers/vehicles/services/plan-kilometers/plan-kilometers-service";
import { VehiclesService } from "src/containers/vehicles/services/vehicles/vehicles-service";
import { WellbeingService } from "src/containers/wellbeing/services/wellbeing/wellbeing-service";
import { BiometricService } from "src/shared/services/biometric/biometric-service";
import { ChatService } from "src/shared/services/chat/chat-service";
import { CookieStorageService } from "src/shared/services/cookie-storage/cookie-storage-service";
import { GoogleAnalyticsService } from "src/shared/services/google-analytics/google-analytics-service";
import { CrmService } from "src/containers/crm/services/crm/crm-service";
import { MedicineDeliveryService } from "src/domains/medicine-delivery/services/delivery/medicine-delivery-service";
import { GeolocationService } from "src/shared/services/geolocation/geolocation-service";
import { ScratchGameService } from "src/containers/wellbeing/rewards/services/scratch-game-service/scratch-game-service";
import { WellbeingRewardsListViewModel } from "src/containers/wellbeing/rewards/presentation/list/list-vm";
import { ScratchGameViewModel } from "src/containers/wellbeing/rewards/presentation/scratch-game/detail/detail-vm";
import { HouseholdViewModel } from "src/containers/household/presentation/household/household-vm";
import { HouseholdCoverageViewModel } from "src/containers/household/presentation/coverage/coverage-vm";
import { EpsDetailViewModel } from "src/containers/eps/presentation/detail/detail-vm";
import { EpsService } from "src/containers/eps/service/eps-service";
import { DacadooRepository } from "src/containers/dacadoo/repositories/dacadoo-repository";
import { DacadooService } from "src/containers/dacadoo/services/dacadoo.service";
import { CardProtectionCoverageViewModel } from "src/containers/card-protection/presentation/coverage/coverage-vm";
import { CardProtectionExclusionViewModel } from "src/containers/card-protection/presentation/exclusion/exclusion-vm";
import { SurveyTransaction } from "src/containers/surveys/lib/survey-transaction";
import { WellbeingRewardsService } from "src/containers/wellbeing/rewards/services/rewards-service/rewards-service";
import { VehicularAssistanceService } from "src/containers/vehicular-assistance/core/services/vehicular-assistance/vehicular-assistance";
import { VehicularAssistanceRepository } from "src/containers/vehicular-assistance/core/repositories/vehicular-assistance/vehicular-assistance-repository";
import { WellbeingRepository } from "src/domains/wellbeing/repositories/wellbeing";
import { WellbeingService as NewWellbeingService } from "src/domains/wellbeing/services/wellbeing";
import { GoogleTagManagerService } from "src/shared/services/google-tag-manager/google-tag-manager-service";
import { GtmTrackingService } from "src/shared/services/google-tag-manager/gtm-tracking-service";
import { GtmPageViewService } from "src/shared/services/google-tag-manager/page-view/gtm-page-view-service";
import { BenefitDiscountsRepository as BenefitV1DiscountsRepository } from "src/domains/benefits/discounts/repositories/discounts/discounts-repository";
import { FetchClient } from "src/infra/http/fetch";

export function setupContainer() {
    DI.put("HttpClient", HttpClient);
    DI.put("HttpUtils", HttpUtils);
    DI.put("PolicyBridgeService", PolicyBridgeService);
    // repositories
    DI.put("GeolocationRepository", GeolocationRepository);
    DI.put("SurveysRepository", SurveysRepository);
    DI.put("CrmRepository", CrmRepository);
    DI.put("CrmRequestRepository", CrmRequestRepository);
    DI.put("AdvertisingRepository", AdvertisingRepository);
    DI.put("AuthenticationRepository", AuthenticationRepository);
    DI.put("PlanKilometersRepository", PlanKilometersRepository);
    DI.put(
        "MedicineDeliveryDocumentRepository",
        MedicineDeliveryDocumentRepository
    );
    DI.put("MedicineDeliveryRepository", MedicineDeliveryRepository);
    DI.put("PolicyRepository", PolicyRepository);
    DI.put("PolicyDetailRepository", PolicyDetailRepository);
    DI.put("BenefitDiscountsRepository", BenefitDiscountsRepository);
    DI.put("VehicleClaimRepository", VehicleClaimRepository);
    DI.put("RentalRepository", RentalRepository);
    DI.put("LifeRepository", LifeRepository);
    DI.put("DocumentsDownloadRepository", DocumentsDownloadRepository);
    DI.put("VoucherDownloadRepository", VoucherDownloadRepository);
    DI.put("NotificationsRepository", NotificationsRepository);
    DI.put("RepaymentObligationsRepository", RepaymentObligationsRepository);
    DI.put("VehiclesRepository", VehiclesRepository);
    DI.put("PaymentSummaryRepository", PaymentSummaryRepository);
    DI.put("HouseholdRepository", HouseholdRepository);
    DI.put("HouseholdClaimRepository", HouseholdClaimRepository);
    DI.put("DacadooRepository", DacadooRepository);
    DI.put("WellbeingRepository", WellbeingRepository);
    DI.put("BenefitV1DiscountsRepository", BenefitV1DiscountsRepository);
    // services
    DI.put("GeolocationService", GeolocationService);
    DI.put("AdvertisingService", AdvertisingService);
    DI.put("AuthenticationService", AuthenticationService);
    DI.put("SessionService", SessionService);
    DI.put("PlanKilometersService", PlanKilometersService);
    DI.put("EpsService", EpsService);
    DI.put("PolicyService", PolicyService);
    DI.put("PolicyDetailService", PolicyDetailService);
    DI.put("HouseholdService", HouseholdService);
    DI.put("HouseholdClaimService", HouseholdClaimService);
    DI.put("SurveysService", SurveysService);
    DI.put("PaymentSummaryService", PaymentSummaryService);
    DI.put("VehiclesService", VehiclesService);
    DI.put("RepaymentObligationsService", RepaymentObligationsService);
    DI.put("NotificationsService", NotificationsService);
    DI.put("VoucherDownloadService", VoucherDownloadService);
    DI.put("DocumentsDownloadService", DocumentsDownloadService);
    DI.put("StaticDocumentDownloadService", StaticDocumentDownloadService);
    DI.put("LifeService", LifeService);
    DI.put("RentalService", RentalService);
    DI.put("VehicleClaimsService", VehicleClaimService);
    DI.put("BenefitDiscountsService", BenefitDiscountsService);
    DI.put("BenefitServingService", BenefitServingService);
    DI.put("PaymentsStorageService", PaymentsStorageService);
    DI.put("CookieStorageService", CookieStorageService);
    DI.put("HealthCarnetService", HealthCarnetService);
    DI.put("WellbeingService", WellbeingService);
    DI.put("GoogleAnalyticsService", GoogleAnalyticsService);
    DI.put("OtpService", OtpService);
    DI.put("BiometricService", BiometricService);
    DI.put("ChatService", ChatService);
    DI.put("CrmRequestsService", CrmRequestsService);
    DI.put("CrmService", CrmService);
    DI.put("MedicineDeliveryService", MedicineDeliveryService);
    DI.put("ScratchGameService", ScratchGameService);
    DI.put("WellbeingRewardsService", WellbeingRewardsService);
    DI.put("VehicularAssistanceService", VehicularAssistanceService);
    DI.put("DacadooService", DacadooService);
    DI.put("SurveyTransaction", SurveyTransaction);
    DI.put("VehicularAssistanceRepository", VehicularAssistanceRepository);
    DI.put("WellbeingService", NewWellbeingService);
    DI.put("GoogleTagManagerService", GoogleTagManagerService);
    DI.put("GtmTrackingService", GtmTrackingService);
    DI.put("GtmPageViewService", GtmPageViewService);
    DI.put("Logger", Logger);
    DI.put("FetchClient", FetchClient);
    // View Models
    DI.put("WellbeingRewardsListViewModel", WellbeingRewardsListViewModel);
    DI.put("ScratchGameViewModel", ScratchGameViewModel);
    DI.put("HouseholdViewModel", HouseholdViewModel);
    DI.put("HouseholdCoverageViewModel", HouseholdCoverageViewModel);
    DI.put("EpsDetailViewModel", EpsDetailViewModel);
    DI.put("CardProtectionCoverageViewModel", CardProtectionCoverageViewModel);
    DI.put(
        "CardProtectionExclusionViewModel",
        CardProtectionExclusionViewModel
    );
    Log.info("DI container ready");
}
